NtechApp.ViewBusinessAccAboutLocationMap = function($view, mapStartCoords) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._mapStartCoords = null;

    this._locationMap = null;
    this._locationMarker = null;

    this._mapRefreshTimeout = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();
        me._mapStartCoords = mapStartCoords;

        me._initLocationMap();

        me._bindEvents();
    }

    this._bindEvents = function() {
        $(window).on(NtechApp.MobileGridNav.EVENT_SELECT_TAB, function(e, col) {
            if(col != "about")
                return;

            google.maps.event.trigger(me._locationMap, 'resize');
            me._locationMap.setCenter(new google.maps.LatLng(me._mapStartCoords));
        });

        $(window).on(NtechApp.MobileGridNav.EVENT_SELECT_SUBTAB, function(e, col) {
            if(col != "about")
                return;

            google.maps.event.trigger(me._locationMap, 'resize');
            me._locationMap.setCenter(new google.maps.LatLng(me._mapStartCoords));
        });

        $(window).on(NtechApp.ViewBusinessAccAboutLocationMap.EVENT_WINDOW_RESIZE, function() {
            clearTimeout(me._mapRefreshTimeout);
            me._mapRefreshTimeout = setTimeout(function() {
                google.maps.event.trigger(me._locationMap, 'resize');
                me._locationMap.setCenter(new google.maps.LatLng(me._mapStartCoords));
            });
        });
    }

    this._unbindEvents = function() {
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ViewBusinessAccAboutLocationMap.EVENT_WINDOW_RESIZE = "resize.NtechApp.ViewBusinessAccAboutLocationMap";

NtechApp.proto(NtechApp.ViewBusinessAccAboutLocationMap, {
    _initLocationMap: function() {
        var me = this;
        var $locationMap = me._$view.find("[data-businessLocationMap]");
        var startCoords = this._mapStartCoords;

        me._locationMap = new google.maps.Map($locationMap.get(0), {
            center: startCoords,
            zoom: 10,
            mapTypeControl: false,
            draggable: false, 
            zoomControl: false, 
            scrollwheel: false, 
            disableDoubleClickZoom: true
        });

        me._locationMarker = new google.maps.Marker({
            position: startCoords,
            map: this._locationMap,
            title: $locationMap.attr("data-locationTitle")
        });
    }
});